import React, { FunctionComponent } from 'react';
import { useTranslation } from 'react-i18next';
import { useFlags } from '../../../hooks/useFlags';
import IsPageOwner from '../../IsPageOwner/IsPageOwner';
import ManualFitnessEntry from '../../ManualFitnessEntry/ManualFitnessEntry';
import styles from './ActionLinks.scss';
import Button from '../../Button/Button';

export type ActionLinksProps = {
  switchPrimaryMeasurementType: () => void;
};

export const ActionLinks: FunctionComponent<ActionLinksProps> = props => {
  const { t } = useTranslation('common', { useSuspense: false });
  const { virtualFitnessEventsDebugFeatures } = useFlags();

  return (
    <div className={styles.container}>
      <IsPageOwner>
        <ManualFitnessEntry
          opener={({ onOpen }) => (
            <Button applyBranding={false} onClick={onOpen}>
              {t('fitness.addManualActivity')}
            </Button>
          )}
        />
      </IsPageOwner>
      {virtualFitnessEventsDebugFeatures && (
        <button
          className={`${styles.linkButton} jg-text--link`}
          data-qa="activity-totals-share"
        >
          {t('common.share')}
        </button>
      )}
      {virtualFitnessEventsDebugFeatures && (
        // NOTE: This enables switching the primary measurement type in the browser.
        // TODO: This should be removed once design of this component is complete.
        <button
          className={`${styles.linkButton} jg-text--link`}
          onClick={props.switchPrimaryMeasurementType}
        >
          Switch measurement type
        </button>
      )}
    </div>
  );
};
